import React, { useContext, useState } from 'react'
import { Formik, Form } from 'formik'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCartPlus } from '@fortawesome/free-solid-svg-icons'
import { CustomToggleShoppingCart } from './resinousFormInputs'
import { AppContext } from '../../../App'
import QuoteActionLinks from '../../QuoteActionLinks'
import QuoteModals from '../../QuoteModals'
import $ from 'jquery'
import toastNotify from '../../../services/toastNotify'
import Loading from '../../loading'
import ResinousAddToCartModal from './ResinousAddToCartModal'

export default function ResinousCoveQuoteCreated() {
   const { 
      coverageDetails,
      calculatedProducts:calculatedProductsRaw,
      productOptionsSelected,
      selectedChip,
      selectedColor,
       unit,
       colorSku,
       colorChipSku,
       colorCoverage,
       colorChipCoverage,
       availableSmallColors,
       availableSmallMvbColors,
       availableSmallVaporBanColors
   } = useContext(AppContext)

   const {
      vaporBarrier,
      height,
      length,
      preferredPackagingSize
   } = coverageDetails.formData    

    const [addToCartError, setAddToCartError] = useState(false)

    let smallColorSku


    if (vaporBarrier) {
        if (vaporBarrier === "Spartacote MVB") {
            smallColorSku = availableSmallMvbColors.map(c => {
                return (c.Name.indexOf(selectedColor) > -1) && c.Sku // Add this item, it matches the package size.
            }).filter(Boolean)
            console.log(smallColorSku)
        } else {
            smallColorSku = availableSmallVaporBanColors.map(c => {
                return (c.Name.indexOf(selectedColor) > -1) && c.Sku // Add this item, it matches the package size.
            }).filter(Boolean)
        }
    } else {
        smallColorSku = availableSmallColors.map(c => {
            return (c.Name.indexOf(selectedColor) > -1) && c.Sku // Add this item, it matches the package size.
        }).filter(Boolean)
    }

   // Adjust calculatedProducts(Raw) coming in from API calculation for correct preferred packaging size.
   // Add all products that are of the correct packaging Size, for BY LAYERS view
   let calculatedProductsForLayersView = calculatedProductsRaw.map(cp => {
      return (cp.unitSize.toLowerCase().indexOf(preferredPackagingSize.toLowerCase()) > -1) && cp // Add this item, it matches the package size.
   }).filter(Boolean)
   calculatedProductsForLayersView.map(cpp => {
      // If any item has product name that includes "pigment kit":
      return cpp.productName.toLowerCase().indexOf('pigment kit') > -1 && (
         calculatedProductsForLayersView.map((p, index) => {
            // If any item has product name that includes "epoxy pigments" or "polyaspartic pigments" or "surface build pigments" or "pigment pt", slice it from the array.
            return (p.productName.toLowerCase().indexOf('epoxy pigments') > -1 || p.productName.toLowerCase().indexOf('polyaspartic pigments') > -1 || p.productName.toLowerCase().indexOf('surface build pigments') > -1 || p.productName.toLowerCase().indexOf('pigment pt') > -1) && calculatedProductsForLayersView.splice(index, 1)
         })
      )
   })

   // Add all products that are of the correct packaging Size, for BY PRODUCTS view
   let calculatedProductsForProductsPreflight = calculatedProductsRaw.map((cp, index) => {
      return (cp.unitSize.toLowerCase().indexOf(preferredPackagingSize.toLowerCase()) > -1) && cp // Add this item, it matches the package size.
   }).filter(Boolean)
   calculatedProductsForProductsPreflight.map(cppp => {
      // If any item has product name that includes "pigment kit":
      return cppp.productName.toLowerCase().indexOf('pigment kit') > -1 && (
         calculatedProductsForProductsPreflight.map((p, index) => {
            // If any item has product name that includes "epoxy pigments" or "polyaspartic pigments" or "surface build pigments", slice it from the array.
            return (p.productName.toLowerCase().indexOf('epoxy pigments') > -1 || p.productName.toLowerCase().indexOf('polyaspartic pigments') > -1 || p.productName.toLowerCase().indexOf('surface build pigments') > -1 || p.productName.toLowerCase().indexOf('pigment pt') > -1) && calculatedProductsForProductsPreflight.splice(index, 1)
         })
      )
   })

   let calculatedProductsForProductsView = [];
   calculatedProductsForProductsPreflight.forEach((cppp, index) => {
      if (index === 0) {
         calculatedProductsForProductsView.push({ ...cppp });
      } else {
         const isExist = calculatedProductsForProductsView.findIndex(
            (el) =>
               el.productName === cppp.productName && el.layerNumber !== cppp.layerNumber
         )
         if (isExist !== -1) {
            calculatedProductsForProductsView[isExist].actualUnitsRequiredDefault = calculatedProductsForProductsView[isExist].actualUnitsRequiredDefault + cppp.actualUnitsRequiredDefault
            calculatedProductsForProductsView[isExist].unitsRequiredDefault = calculatedProductsForProductsView[isExist].unitsRequiredDefault + cppp.unitsRequiredDefault
         } else {
            calculatedProductsForProductsView.push({ ...cppp })
         }
      }
   });

   function initializeNumberOfLayers() {
      let numberOfLayers = []
      // Determine the total number of resinous layers. Push each layerNumber to a storage array, numberOfLayers, for reference.
      calculatedProductsForLayersView.map(cp => {
         return numberOfLayers.push(cp.layerNumber)
      })
      // Set a new array of the number of layers, removing duplicates.
      let setNumberofLayers = [...new Set(numberOfLayers)]
      // Sort numberOfLayers so rendering of data is in order, with Layer 1 first, on top.
      return setNumberofLayers.sort()
   }

   // If unit is metric, convert length to imperial for calculation (to linear feet)
   const convertedLength = unit==="sqm" ? (
      length/3.28084 // THIS IS NOW IN FEET
   ) : (
      length // THIS IS NOW IN FEET
   )
   // Isolate inches value from "height" variable, which is a string that includes " in."
   const inches = height.charAt(0)
   const totalArea = convertedLength * (inches/12)
   const productType = productOptionsSelected.productOptions[1]
   const iconCartPlus = <FontAwesomeIcon icon={ faCartPlus } color="#00a8d5" />
   const sortedNumberOfLayers = initializeNumberOfLayers()

    // Handle "Add to Cart" button click.
    const handleAddToCart = (values) => {
        setAddToCartError(false)

        var arr = [];
        Object.keys(values).forEach(function (key) {
            if (values[key]) {
                arr.push(key);
            }
        });

        // Prepare the data from the form of items selected to add to cart
        const productNamesSkusQuantitiesRaw = arr
        let productNamesSkusQuantities = productNamesSkusQuantitiesRaw.map(p => {
            return p.split(',')
        })

        let productSkus = productNamesSkusQuantities.map(p => p[0])
        let productQuantities = productNamesSkusQuantities.map(p => p[1])

        let uomsArray = productNamesSkusQuantities.map(p => "EA")

        let dataForCart = {
            "Items": [...productSkus],
            "UOMs": [...uomsArray],
            "Quantities": [...productQuantities],
            "ItemNumberIsShortItemNumber": false
        }

        productSkus = []
        productQuantities = []
        uomsArray = []

        function callCart(dataForCart) {
            console.log(dataForCart)
            //Clear the cart
            $.ajax({
                type: "POST",
                dataType: "json",
                xhrFields: { withCredentials: true },
                url: "https://my.laticrete.com/ECO/Services/scShoppingProcess/ClearShoppingCart",
                success: function (data) {
                    // const message = "Success! Shopping cart is now cleared."
                    // const type = "success"
                    // toastNotify(message, type)
                },
                error: function (xhr, error) {
                    setAddToCartError("There was a problem adding to cart.")
                    const message = "Error. Shopping cart could not be cleared."
                    const type = "error"
                    toastNotify(message, type)
                }
            }).done(function () {
                // Send product data object to the cart
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    xhrFields: { withCredentials: true },
                    data: dataForCart,
                    url: "https://my.laticrete.com/ECO/Services/scShoppingProcess/AddItemsToCart",
                    success: function () {
                        const message = "Success! Cart has been updated with new items."
                        const type = "success"
                        toastNotify(message, type)
                    },
                    error: function () {
                        setAddToCartError("There was a problem adding to cart.")
                        const message = "Error. Items could not be added to cart."
                        const type = "error"
                        toastNotify(message, type)
                    }
                }).done(function (response) {
                    const message = "Items added to cart. Redirecting to my.laticrete.com."
                    const type = "success"
                    toastNotify(message, type)
                    window.location.href = "https://my.laticrete.com/shopping-cart";
                })
            }).fail(function () {
                setAddToCartError("There was a problem adding to cart.")
            })
        }

        // Ensure product(s) are selected then send to cart. If not, throw error.
        Object.values(values).includes(true) ? (
            callCart(dataForCart)
            // SAMPLE DATA STRUCTURE
            // {
            //     "Items":["9140-0002-2","9302-0055-2","9236-0001-22","9811-0005-2","9807-0005-2"],
            //     "UOMs":["EA","EA","EA","EA","EA"],
            //     "Quantities":["5","4","2","2","2"],
            //    "ItemNumberIsShortItemNumber":false
            // }
        ) : (
            setAddToCartError("No products selected. Please select products.")
        )
    }
   
   return (
      <div className="data-table-wrapper">
         <div className="col-xs-12">
               <h3 className="quote-heading">Coverage Details <span className="small">(<strong>Preferred Packaging Size:</strong> {preferredPackagingSize})</span></h3>
            <div className="data-table">
               <div className="row hidden-xs">
                  <div className="col-xs-12 col-sm-4">Total Area</div>
                  <div className="col-xs-12 col-sm-4">Vapor Barrier</div>
                  { selectedChip && <div className="col-xs-12 col-sm-4">Quartz Selection</div> }
               </div>
               <div className="row p-1">
                  <div className="col-xs-12 col-sm-4">
                     <div className="row p-1">
                        <div className="col-xs-6 visible-xs">
                           <strong>Total Area: </strong>
                        </div>
                        <div className="col-xs-6 col-sm-12">
                        { totalArea.toLocaleString('en') }{ unit==="sqft" ? " ft\u00B2" : " m\u00B2" }
                        </div>
                     </div>
                  </div>
                  <div className="col-xs-12 col-sm-4">
                     <div className="row p-1">
                        <div className="col-xs-6 visible-xs">
                           <strong>Vapor Barrier: </strong>
                        </div>
                        <div className="col-xs-6 col-sm-12">
                        { vaporBarrier ? vaporBarrier : "None" }
                        </div>
                     </div>
                  </div>
                  { selectedChip && 
                  <div className="col-xs-12 col-sm-4">
                     <div className="row p-1">
                        <div className="col-xs-6 visible-xs">
                           <strong>Quartz Selection: </strong>
                        </div>
                        <div className="col-xs-6 col-sm-12">
                        { selectedChip }
                        </div>
                     </div>
                  </div>
                  }
                  { selectedColor && 
                  <div className="col-xs-12 col-sm-4">
                     <div className="row p-1">
                        <div className="col-xs-6 visible-xs">
                           <strong>Selected Color:</strong>
                        </div>
                        <div className="col-xs-6 col-sm-12">
                        { selectedColor }
                        </div>
                     </div>
                  </div>
                  }
               </div>
            </div>
            
         </div>
         <div className="col-xs-12">
            <hr />
         </div>
         <div className="col-xs-12">
            <h3 className="quote-heading">Supplies</h3>
            { calculatedProductsRaw.length===0 ? (
            <Loading type="products required" />
            ) : (
            <React.Fragment>
               <ul className="nav nav-pills nav-justified resinous-supplies-toggle">
                  <li className="active"><a data-bs-toggle="pill" href="#by-product">VIEW BY PRODUCT</a></li>
                  <li><a data-bs-toggle="pill" href="#by-layer">VIEW BY LAYER</a></li>
               </ul>
               <div className="tab-content"> 
                  <div id="by-product" className="tab-pane fade in active">
                     <Formik initialValues={{  }} onSubmit={ (values) => { handleAddToCart(values) } } >
                     {
                     props => (
                        <Form>
                           <div className="data-table">
                              <div className="row hidden-xs">
                                 <div className="col-xs-12 col-sm-2">Item/Sku #</div>
                                 <div className="col-xs-12 col-sm-2">Product Name</div>
                                 <div className="col-xs-12 col-sm-2">Unit Size</div>
                                 <div className="col-xs-12 col-sm-2">Required Units</div>
                                 <div className="col-xs-12 col-sm-2 hidden-print">Add to Cart</div>
                              </div>
                              {
                              // Create a table row for each product.
                              calculatedProductsForProductsView.map((cp, index) => {
                              return (
                              // BEGIN PRODUCT ROW
                              <div className="row" key={ cp.layerNumber+cp.productName+index }>
                                 <div className="col-xs-12 col-sm-2">
                                    <div className="row p-1">
                                       <div className="col-xs-6 visible-xs">
                                          <strong>Item/Sku #:</strong>
                                       </div>
                                       <div className="col-xs-6 col-sm-12">
                                                  {(cp.colors && colorSku && cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && cp.isPigmentKit == "false") && !(cp.unitForDisplayOnly == "SMALL" && preferredPackagingSize == "Large") &&
                                                      colorSku
                                                  }
                                                  {(cp.colors && colorSku && cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && cp.isPigmentKit == "false" && (cp.unitForDisplayOnly == "SMALL" && preferredPackagingSize == "Large")) &&
                                                      smallColorSku
                                                  }
                                                  {(cp.colors && colorChipSku && (cp.theseAreChipColors == "true" || cp.theseAreQuartzColors == "true")) &&
                                                      colorChipSku
                                                  }
                                                  {(!cp.colors || cp.isPigmentKit == "true") &&
                                                      cp.sku
                                                  }
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-xs-12 col-sm-2">
                                    <div className="row p-1">
                                       <div className="col-xs-6 visible-xs">
                                          <strong>Product Name:</strong>
                                       </div>
                                       <div className="col-xs-6 col-sm-12">
                                       { // "PRODUCT NAME"
                                          cp.productName || "Product name missing"
                                       }
                                       
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-xs-12 col-sm-2">
                                    <div className="row p-1">
                                       <div className="col-xs-6 visible-xs">
                                          <strong>Unit Size:</strong>
                                       </div>
                                       <div className="col-xs-6 col-sm-12">
                                       { // "UNIT SIZE"
                                          cp.unitForDisplayOnly || `${cp.unitCount} ${cp.unit}`
                                       }
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-xs-12 col-sm-2">
                                    <div className="row p-1">
                                       <div className="col-xs-6 visible-xs">
                                          <strong>Required Units:</strong>
                                       </div>
                                       <div className="col-xs-6 col-sm-12">
                                                  {(() => {
                                                      if (cp.theseAreChipColors == "true") {
                                                          var chips = JSON.parse(cp.colors);

                                                          var chip = chips.map(c => {
                                                              return (c.Name.indexOf(selectedChip) > -1) && c.UnitsRequired
                                                          }).filter(Boolean);
                                                          return chip;
                                                      } else {
                                                          return Math.ceil(cp.actualUnitsRequiredDefault)
                                                      }
                                                  }
                                                  )()}
                                       </div>
                                    </div>
                                 </div>
                                      { cp.isSoldOnline == "true" &&
                                          <div className="col-xs-12 col-sm-2 hidden-print">
                                              <div className="row p-1">
                                                  <div className="col-xs-6 visible-xs">
                                                      <strong>Add to cart:</strong>
                                                  </div>
                                                  <div className="col-xs-6 col-sm-12">

                                                      {(cp.colors && colorSku && cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && cp.isPigmentKit == "false") && !(cp.unitForDisplayOnly == "SMALL" && preferredPackagingSize == "Large") &&
                                                          <CustomToggleShoppingCart
                                                              name={
                                                                  [colorSku, cp.unitsRequiredDefault]
                                                              }
                                                          />
                                                      }
                                                      {(cp.colors && colorSku && cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && cp.isPigmentKit == "false" && (cp.unitForDisplayOnly == "SMALL" && preferredPackagingSize == "Large")) &&
                                                          <CustomToggleShoppingCart
                                                              name={
                                                                  [smallColorSku, cp.unitsRequiredDefault]
                                                              }
                                                          />
                                                      }
                                                      {(cp.colors && colorChipSku && (cp.theseAreChipColors == "true" || cp.theseAreQuartzColors == "true")) &&
                                                          <CustomToggleShoppingCart
                                                              name={
                                                                  [colorChipSku, cp.unitsRequiredDefault]
                                                              }
                                                          />
                                                      }
                                                      {(!cp.colors || cp.isPigmentKit == "true") &&
                                                          <CustomToggleShoppingCart
                                                              name={
                                                                  [cp.sku, cp.unitsRequiredDefault]
                                                              }
                                                          />
                                                      }
                                                  </div>
                                              </div>
                                          </div>
                                      }
                              </div>       
                                    )
                                 })
                              }
                           </div>
                           <div className="row hidden-print">
                              <div className="col-xs-12 col-sm-4 col-sm-push-8 col-lg-3 col-lg-push-9">
                                 <button type="submit" className="btn btn-primary btn-lg btn-block btn-add-to-cart" data-bs-toggle="modal" data-bs-target="#modal-addToCart">{ iconCartPlus } ADD TO CART</button>
                              </div>
                              <QuoteActionLinks productType={ productType } />
                           </div>
                        </Form>
                     )}
                     </Formik>
                  </div>
                  {
                     // ***************** Table by layers ***************** //
                  }
                  <div id="by-layer" className="tab-pane fade">
                  {
                     sortedNumberOfLayers.map((n, index) => {
                     return (
                     <div key={ 'layer-table-' + n } >
                        <h4>
                           <strong>{ `Layer ${ index + 1 }` }</strong>
                        </h4>
                        <p><strong>Thickness: { [...new Set(calculatedProductsForLayersView.map(cp => cp.layerNumber===n && cp.thickness).filter(Boolean))] }</strong></p>
                        <div className="data-table" key={ n + "_" + index }>
                           <div className="row hidden-xs">
                              <div className="col-xs-12 col-sm-3">Item/Sku #</div>
                              <div className="col-xs-12 col-sm-3">Product Name</div>
                                     <div className="col-xs-12 col-sm-3">Coverage</div>
                                     <div className="col-xs-12 col-sm-3">Required Amount</div>
                           </div>
                     {
                     // Create a table row for each product assigned to this layer.
                     calculatedProductsForLayersView.map(cp => {
                     return (
                        cp.layerNumber===n && (
                           <div className="row" key={ n+"-"+cp.sku }>
                              <div className="col-xs-12 col-sm-3 quote-data-mobile-view">
                                 <div className="row p-1">
                                    <div className="col-xs-6 visible-xs">
                                       <strong>Item/Sku #: </strong>
                                    </div>
                                    <div className="col-xs-6 col-sm-12">
                                             {(cp.colors && colorSku && cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && cp.isPigmentKit == "false") && !(cp.unitForDisplayOnly == "SMALL" && preferredPackagingSize == "Large") &&
                                                 colorSku
                                             }
                                             {(cp.colors && colorSku && cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && cp.isPigmentKit == "false" && (cp.unitForDisplayOnly == "SMALL" && preferredPackagingSize == "Large")) &&
                                                 smallColorSku
                                             }
                                             {(cp.colors && colorChipSku && (cp.theseAreChipColors == "true" || cp.theseAreQuartzColors == "true")) &&
                                                 colorChipSku
                                             }
                                             {(!cp.colors || cp.isPigmentKit == "true") &&
                                                 cp.sku
                                             }
                                    </div>
                                 </div>
                              </div>
                              <div className="col-xs-12 col-sm-3 quote-data-mobile-view">
                                 <div className="row p-1">
                                    <div className="col-xs-6 visible-xs">
                                       <strong>Product Name: </strong>
                                    </div>
                                    <div className="col-xs-6 col-sm-12">
                                    { 
                                       // Product Name
                                       cp.productName || "Product name missing"
                                    }
                                    </div>
                                 </div>
                              </div>
                              
                              <div className="col-xs-12 col-sm-3 quote-data-mobile-view">
                                 <div className="row p-1">
                                    <div className="col-xs-6 visible-xs">
                                       <strong>Coverage: </strong>
                                    </div>
                                    <div className="col-xs-6 col-sm-12">
                                             {(cp.colors && colorSku && cp.theseAreChipColors == "false" && colorCoverage != 0) &&
                                                 colorCoverage
                                             }
                                             {(cp.colors && colorSku && cp.theseAreChipColors == "false" && colorCoverage == 0 && cp.isPigmentKit == "false" && cp.theseAreQuartzColors == "false") &&
                                                 cp.coverage
                                             }
                                             {(cp.colors && colorChipSku && cp.theseAreChipColors == "true") &&
                                                 colorChipCoverage
                                             }
                                             {(cp.theseAreQuartzColors == "true") &&
                                                 cp.coverage
                                             }
                                             {!cp.colors &&
                                                 cp.coverage
                                             }

                                             {
                                                 (cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && cp.colors) &&
                                                 (
                                                     unit === "sqft" ? (
                                                         ` ft\u00B2/${cp.unit}`
                                                     ) : (
                                                             ` m\u00B2/${cp.unit}`
                                                         )
                                                 )
                                             }
                                             {
                                                 (cp.theseAreChipColors == "false" && cp.theseAreQuartzColors == "false" && !cp.colors) &&
                                                 (
                                                     unit === "sqft" ? (
                                                         " ft\u00B2/gal"
                                                     ) : (
                                                             " m\u00B2/L"
                                                         )
                                                 )
                                             }
                                             {
                                                 (cp.colors && colorChipSku && (cp.theseAreChipColors == "true" || cp.theseAreQuartzColors == "true")) &&
                                                 (unit === "sqft" ? (
                                                     " ft\u00B2/lb"
                                                 ) : (
                                                         " m\u00B2/kg"
                                                     )
                                                 )
                                             }
                                    </div>
                                 </div>
                                 </div>
                                 <div className="col-xs-12 col-sm-3 quote-data-mobile-view">
                                     <div className="row p-1">
                                         <div className="col-xs-6 visible-xs">
                                             <strong>Required Amount #: </strong>
                                         </div>
                                         <div className="col-xs-6 col-sm-12">
                                             {(cp.theseAreChipColors == "false") &&

                                                 cp.requiredAmount

                                             }

                                             {(() => {
                                                 if (cp.theseAreChipColors == "true") {
                                                     var chips = JSON.parse(cp.colors);

                                                     var chip = chips.map(c => {
                                                         return (c.Name.indexOf(selectedChip) > -1) && c.RequiredAmount
                                                     }).filter(Boolean);
                                                     return chip;
                                                 }
                                             }
                                             )()}


                                             {

                                                 (unit === "mm" && cp.unit === "gal" || cp.unit === "qt") ?
                                                     " L" :
                                                     (cp.unit === "lb") ? " lbs" : ` ${cp.unit}`
                                             }
                                         </div>
                                     </div>
                                 </div>
                           </div>
                           ))})}
                        </div>
                     </div>
                     )})}
                  </div>
               </div>
               </React.Fragment>
               )
            }
         </div>
      <QuoteModals />
      <ResinousAddToCartModal error={ addToCartError } />
   </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/resinous/ResinousCoveQuoteCreated.js